import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { User } from "@models/user";
import { HttpService } from "@services/http-service";
import { isArray } from "ngx-bootstrap/chronos";

@Injectable({
  providedIn: "root"
})
export class UserService extends HttpService {
  private user = new BehaviorSubject<User | undefined>(undefined);

  constructor() {
    super();
  }

  public setUser(user: User): void {
    this.user.next(user);
  }

  public getUser(): Observable<User | undefined> {
    return this.user.asObservable();
  }

  public removeUser(): void {
    this.user.next(undefined);
  }

  public hasPermissionTo(permission: string): boolean {
    if (!this.user.value) {
      return false;
    }

    return this.user.value.permissions
      .map((p: string) => p.toString())
      .includes(permission);
  }

  public hasRole(role: string|Array<string>): boolean {
    if (isArray(role) && this.user.value?.role.name) {
      return role.includes(this.user.value.role.name);
    }

    return this.user.value?.role.name === role;
  }
}
